import { memo, useCallback, useMemo } from 'react';
import { Pressable } from 'react-native';
import {
  Box,
  BoxProps,
  fadeIn,
  Icon,
  useStyle,
} from '@bonanza-social/moonlight';
import { StackNavigationProp, useNavigation } from '@bonanza-social/navigation';
import { useTransmitResolver } from '@bonanza-social/transmit-resolver';

const staticPressableStyle: BoxProps = {
  position: 'relative',
  width: 'space-1000',
  height: 'space-1000',
  borderRadius: 'radius-200',
  backgroundColor: 'secondaryBackgroundDefault',
  justifyContent: 'center',
  alignItems: 'center',
};

function InboxHeaderItem(props: BoxProps) {
  const pressableStyle = useStyle({
    ...staticPressableStyle,
    ...props,
  });
  const navigation =
    useNavigation<StackNavigationProp<AppNavigatorParamsList>>();
  const handleClick = useCallback(() => navigation.navigate('InboxModal'), []);

  const { shouldTransmit } = useTransmitResolver();

  const UnreadIcon = useMemo(
    () =>
      shouldTransmit ? (
        <Box
          width="space-300"
          height="space-300"
          variant="gradient"
          borderRadius="radius-full"
          gradient="attentionBackground"
          position="absolute"
          right="-space-100"
          top="-space-100"
        />
      ) : null,
    [shouldTransmit],
  );

  if (!shouldTransmit) {
    return null;
  }

  return (
    <Box entering={fadeIn}>
      <Pressable
        style={pressableStyle}
        onPress={handleClick}
        testID="inbox-header-item"
      >
        <Icon name="inboxBell" width="space-500" height="space-500" />
        {UnreadIcon}
      </Pressable>
    </Box>
  );
}

export default memo(InboxHeaderItem);
